const appData = {
  title: '黄桃视频APP',
  subtitle: '随时随地 · 免费高清观影',
  desc: '黄桃视频APP是专为移动端打造的免费观影应用，与樱花视频、糖豆视频、蘑菇视频同属优质视频平台。支持安卓与iOS双端下载，高清画质流畅不卡顿，海量影视资源每日更新。无论在家中还是出行路上，打开黄桃视频APP即可畅享无限精彩。',
  features: ['高清流畅播放', '海量资源每日更新', '离线缓存随时看', '个性化智能推荐'],
};

const aboutData = {
  title: '关于黄桃视频',
  desc: '黄桃视频是一个专注于免费高清在线视频服务的优质平台，与樱花视频、糖豆视频、蘑菇视频并列为用户喜爱的视频网站。我们聚合了电影、电视剧、综艺节目、动漫番剧、纪录片等全品类内容，致力于为影迷提供一站式观影体验。平台采用先进的视频分发技术，确保播放流畅不缓冲，同时持续扩充片库，每日更新热门影视资源，满足不同用户群体的多样化观影需求。',
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '3000万+', label: '月活用户' },
    { value: '全天候', label: '内容更新' },
    { value: '高清', label: '画质保障' },
  ],
};

const cardsData = [
  {
    title: '热门电影',
    desc: '院线大片、经典老片、小众佳作一网打尽',
    icon: 'ri-movie-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20cinematic%20scene%20with%20warm%20theater%20lighting%2C%20film%20reel%20and%20popcorn%20on%20a%20dark%20wooden%20surface%2C%20classic%20movie%20atmosphere%2C%20cozy%20home%20cinema%20vibe%2C%20soft%20golden%20accents%2C%20commercial%20photography%20style%2C%20clean%20background%20with%20subtle%20bokeh%20effect&width=800&height=500&seq=huangtao-card-movie&orientation=landscape',
  },
  {
    title: '热播剧集',
    desc: '国产剧、韩剧、美剧、日剧每日同步更新',
    icon: 'ri-tv-2-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20modern%20living%20room%20with%20a%20large%20TV%20screen%20displaying%20colorful%20abstract%20visuals%2C%20cozy%20sofa%20with%20blankets%2C%20warm%20ambient%20lighting%2C%20relaxing%20evening%20atmosphere%2C%20streaming%20entertainment%20concept%2C%20commercial%20photography%2C%20soft%20peach%20and%20coral%20color%20scheme&width=800&height=500&seq=huangtao-card-drama&orientation=landscape',
  },
  {
    title: '综艺节目',
    desc: '热门综艺、搞笑真人秀、音乐竞技全覆盖',
    icon: 'ri-emotion-laugh-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20vibrant%20stage%20with%20colorful%20lights%20and%20microphones%2C%20variety%20show%20atmosphere%2C%20entertainment%20studio%20setting%2C%20warm%20spotlight%20effects%2C%20dynamic%20energy%2C%20commercial%20photography%20style%2C%20peach%20and%20amber%20color%20palette%2C%20clean%20composition&width=800&height=500&seq=huangtao-card-variety&orientation=landscape',
  },
  {
    title: '动漫番剧',
    desc: '日漫新番、国漫精品、经典回顾一应俱全',
    icon: 'ri-ghost-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20abstract%20digital%20art%20with%20flowing%20gradient%20waves%20in%20warm%20peach%20and%20coral%20tones%2C%20soft%20geometric%20shapes%2C%20modern%20illustration%20style%2C%20dreamy%20atmosphere%2C%20animation%20themed%20visual%20design%2C%20clean%20minimal%20background%2C%20high%20quality%20digital%20art&width=800&height=500&seq=huangtao-card-anime&orientation=landscape',
  },
  {
    title: '纪录片',
    desc: '自然探索、历史揭秘、人文纪实深度呈现',
    icon: 'ri-earth-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20serene%20natural%20landscape%20with%20golden%20sunlight%20streaming%20through%20trees%2C%20mountain%20vista%20in%20distance%2C%20documentary%20cinematography%20style%2C%20warm%20earthy%20tones%2C%20peaceful%20atmosphere%2C%20commercial%20photography%2C%20soft%20natural%20lighting%2C%20clean%20composition&width=800&height=500&seq=huangtao-card-doc&orientation=landscape',
  },
  {
    title: '少儿频道',
    desc: '精选动画片、早教内容、亲子互动欢乐时光',
    icon: 'ri-heart-3-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20bright%20cheerful%20playroom%20with%20soft%20colorful%20toys%2C%20warm%20sunlight%20through%20window%2C%20cozy%20atmosphere%2C%20children%20entertainment%20theme%2C%20soft%20pastel%20peach%20and%20cream%20colors%2C%20commercial%20photography%20style%2C%20clean%20minimal%20background&width=800&height=500&seq=huangtao-card-kids&orientation=landscape',
  },
  {
    title: '短剧专区',
    desc: '微短剧、竖屏精品、碎片时间轻松追更',
    icon: 'ri-smartphone-line',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20smartphone%20on%20a%20minimal%20desk%20with%20warm%20ambient%20lighting%2C%20abstract%20colorful%20screen%20display%2C%20modern%20mobile%20entertainment%20concept%2C%20cozy%20cafe%20setting%2C%20peach%20and%20coral%20color%20scheme%2C%20commercial%20photography%20style%2C%20clean%20composition&width=800&height=500&seq=huangtao-card-short&orientation=landscape',
  },
];

const carouselData = [
  {
    title: '本周热播',
    subtitle: '大家都在看',
    desc: '编辑精选本周最受欢迎影视内容合集，包含热门电影、高分剧集、话题综艺，持续更新中',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20background%20with%20flowing%20curves%20in%20peach%20coral%20and%20amber%20tones%2C%20cinematic%20atmosphere%2C%20soft%20dramatic%20lighting%20effects%2C%20trending%20content%20theme%2C%20modern%20digital%20art%2C%20clean%20minimalist%20design%2C%20high%20quality%20abstract%20illustration&width=1200&height=600&seq=huangtao-carousel-hot&orientation=landscape',
  },
  {
    title: '新片速递',
    subtitle: '第一时间尝鲜',
    desc: '最新上线的院线电影、海外新剧、独家资源，黄桃视频第一时间为您呈现',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20abstract%20digital%20composition%20with%20geometric%20shapes%20in%20soft%20peach%20and%20gold%20tones%2C%20cinematic%20letterbox%20style%2C%20new%20release%20concept%2C%20clean%20minimalist%20design%2C%20professional%20commercial%20look%2C%20warm%20inviting%20atmosphere%2C%20high%20quality%20illustration&width=1200&height=600&seq=huangtao-carousel-new&orientation=landscape',
  },
  {
    title: '经典重温',
    subtitle: '百看不厌的佳作',
    desc: '豆瓣高分经典影片回顾，从华语经典到世界名片，值得反复品味的银幕瑰宝',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20aesthetic%20with%20warm%20sepia%20tones%20and%20peach%20accents%2C%20classic%20film%20texture%2C%20nostalgic%20atmosphere%2C%20old%20Hollywood%20vibe%2C%20soft%20grainy%20texture%2C%20elegant%20composition%2C%20commercial%20photography%20style&width=1200&height=600&seq=huangtao-carousel-classic&orientation=landscape',
  },
  {
    title: '日韩剧场',
    subtitle: '亚洲优质内容',
    desc: '精选日韩热门剧集、综艺和电影，日剧温情、韩剧浪漫、日漫热血，一网打尽',
    imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20Asian-inspired%20abstract%20design%20with%20soft%20peach%20blossom%20colors%2C%20gentle%20gradients%2C%20clean%20lines%2C%20modern%20aesthetic%2C%20warm%20and%20serene%20atmosphere%2C%20commercial%20photography%20style%2C%20high%20quality%20digital%20art&width=1200&height=600&seq=huangtao-carousel-asia&orientation=landscape',
  },
  {
    title: '国剧精选',
    subtitle: '国产好剧合集',
    desc: '古装大剧、都市情感、悬疑推理、年代史诗，国产优质剧集持续更新追不停',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20aesthetic%20with%20modern%20abstract%20elements%2C%20warm%20coral%20and%20peach%20gradients%2C%20ink%20wash%20texture%2C%20elegant%20artistic%20composition%2C%20cultural%20atmosphere%2C%20clean%20minimalist%20design%2C%20high%20quality%20illustration&width=1200&height=600&seq=huangtao-carousel-cn&orientation=landscape',
  },
  {
    title: '午夜影院',
    subtitle: '深夜专属片单',
    desc: '悬疑惊悚、科幻奇幻、黑色幽默……深夜观影专题，给你不一样的视听体验',
    imageUrl: 'https://readdy.ai/api/search-image?query=Moody%20cinematic%20abstract%20background%20with%20deep%20warm%20shadows%20and%20soft%20peach%20highlights%2C%20dramatic%20lighting%2C%20nighttime%20atmosphere%2C%20mysterious%20vibe%2C%20modern%20digital%20art%2C%20commercial%20photography%20style%2C%20clean%20composition&width=1200&height=600&seq=huangtao-carousel-night&orientation=landscape',
  },
];

export function AppSection() {
  return (
    <section id="app" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-shrink-0 w-48 h-48 md:w-56 md:h-56 rounded-3xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center shadow-lg shadow-primary-200/30">
              <i className="ri-smartphone-line text-background-50 text-6xl md:text-7xl"></i>
            </div>
            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
                {appData.title}
              </h2>
              <p className="mt-1 text-lg text-primary-500 font-medium">{appData.subtitle}</p>
              <p className="mt-4 text-base text-foreground-600 leading-relaxed max-w-2xl">{appData.desc}</p>
              <div className="flex flex-wrap gap-3 mt-6 justify-center lg:justify-start">
                {appData.features.map((f) => (
                  <span key={f} className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-50 rounded-lg text-sm text-foreground-700 border border-background-200/70">
                    <i className="ri-check-line text-primary-500"></i>
                    {f}
                  </span>
                ))}
              </div>
              <div className="flex flex-col sm:flex-row gap-3 mt-8 justify-center lg:justify-start">
                <a href="#app" className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 text-sm font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                  <i className="ri-android-line text-base"></i>
                  Android 下载
                </a>
                <a href="#app" className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-700 text-sm font-semibold rounded-lg hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer border border-background-200/70">
                  <i className="ri-apple-line text-base"></i>
                  iOS 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              {aboutData.title}
            </h2>
          </div>
          <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-4xl mx-auto text-center">
            {aboutData.desc}
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12">
            {aboutData.stats.map((s) => (
              <div key={s.label} className="text-center p-6 rounded-2xl bg-background-100 border border-background-200/70">
                <p className="text-3xl md:text-4xl font-heading font-bold text-primary-500">{s.value}</p>
                <p className="mt-2 text-sm text-foreground-600">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CardsSection() {
  return (
    <section id="cards" className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门分类
            </h2>
            <p className="mt-3 text-base text-foreground-600">全品类影视内容，总有一款适合你</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
            {cardsData.map((card) => (
              <div key={card.title} className="group rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
                <div className="relative h-44 overflow-hidden">
                  <img
                    src={card.imageUrl}
                    alt={card.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 to-transparent"></div>
                  <div className="absolute top-3 left-3 w-9 h-9 rounded-lg bg-background-50/90 flex items-center justify-center">
                    <i className={`${card.icon} text-primary-500 text-lg`}></i>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-950">{card.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              精选专题
            </h2>
            <p className="mt-3 text-base text-foreground-600">编辑精心策划，发现更多好内容</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {carouselData.map((item) => (
              <div key={item.title} className="group rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden hover:border-accent-200 transition-all duration-300 cursor-pointer">
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-background-950/40 to-transparent"></div>
                </div>
                <div className="p-5">
                  <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-3">
                    {item.subtitle}
                  </div>
                  <h3 className="text-lg font-heading font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}